export default __webpack_public_path__ + "static/media/html.b1777a58.png";